// extracted by mini-css-extract-plugin
export default {"wrapper":"Link_wrapper__Wm+NJ","popup":"Link_popup__eEWMw"};